exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-myers-briggs-js": () => import("./../../../src/pages/myers-briggs.js" /* webpackChunkName: "component---src-pages-myers-briggs-js" */),
  "component---src-pages-spiritual-gifts-js": () => import("./../../../src/pages/spiritual-gifts.js" /* webpackChunkName: "component---src-pages-spiritual-gifts-js" */)
}

